import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';


@Component({
  selector: 'app-code-used',
  templateUrl: './code-used.component.html',
  styleUrls: ['./code-used.component.scss']
})
export class CodeUsedComponent {
  constructor(private http: HttpClient,
    private alert: AlertService
  ) {

  }

  codeItem: any
  GetCode(v: any) {
    this.http.post(`code/used`, { Code: v.value }).subscribe({
      next: (res: any) => {
        this.codeItem = res.data
      },
      error: (err) => {
        this.alert.dialog(err.error.message)
      }
    })
  }

  close() {
    this.alert.confirm('คุณแน่ใจตรวจสอบสิทธิ์เรียบร้อยแล้ว ต้องการปิดหรือไม่').then(fm => {
      if (fm.isConfirmed) {
        this.codeItem = ''
      }
    })
  }
}
